import { View } from 'foundations-components/components/View';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyOverviewCard = ({
  children,
  maxInlineSize = '300px',
  paddingBlockEnd,
  marginInline = 'auto'
}) => /*#__PURE__*/_jsx(View, {
  marginInline: marginInline,
  maxInlineSize: maxInlineSize,
  paddingBlockEnd: paddingBlockEnd,
  children: /*#__PURE__*/_jsxs(View, {
    marginBlock: "600",
    role: "alert",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(Pictogram, {
      inlineSize: "100%",
      marginBlockEnd: "600",
      name: "EmptyStateSearch"
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      children: children
    })]
  })
});
export default EmptyOverviewCard;